<template>
  <div class="freezen-bill-list">
    <div class="c_page-title">
      <div>冻结单列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px">
                <el-form-item label="输入搜索：">
                  <div style="display: flex; flex-direction: row">
                    <div class="freezen-item">
                      <el-input
                        v-model="form.supply_id"
                        placeholder="商家id"
                        @keyup.native.enter="search"
                      ></el-input>
                    </div>

                    <div class="freezen-item">
                      <el-input
                        v-model="form.supply_name"
                        placeholder="商家名称"
                        @keyup.native.enter="search"
                      ></el-input>
                    </div>
                    <div class="freezen-item">
                      <el-select
                        v-model="form.pgid"
                        filterable
                        placeholder="代采组"
                        @change="getPgMember"
                      >
                        <el-option value="0" label="全部"></el-option>
                        <el-option
                          v-for="(item, index) in pgOption"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>

                    <div class="freezen-item">
                      <el-select
                        v-model="form.pg_member_id"
                        filterable
                        placeholder="代采员"
                      >
                        <el-option value="0" label="全部"></el-option>
                        <el-option
                          v-for="(item, index) in pgMember"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>

                    <div class="freezen-item">
                      <el-input
                        v-model="form.transfer_admin"
                        placeholder="转账人"
                        @keyup.native.enter="search"
                      ></el-input>
                    </div>

                    <div class="freezen-item">
                      <el-select
                        v-model="form.status"
                        multiple
                        placeholder="冻结状态"
                      >
                        <el-option
                          v-for="item in freezenOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </el-form-item>
                <div style="display: flex; flex-direction: row">
                  <el-form-item label="冻结日期:" class="select-container">
                    <el-date-picker
                      v-model="form.create_time"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="解冻日期:" class="select-container">
                    <el-date-picker
                      v-model="form.unfreeze_time"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="转账日期:" class="select-container">
                    <el-date-picker
                      v-model="form.pay_time"
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      style="margin-left: 15px"
                      type="primary"
                      @click="search()"
                      >搜索</el-button
                    >
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 40px;
            line-height: 40px;
            padding: 0 25px;
            display: flex;
            align-items: center;
            position: relative;
          "
        >
          <div>数据列表：</div>
          <div style="position: absolute; right: 0; top: 0">
            <el-button
              style="margin-left: auto"
              type="primary"
              size="mini"
              @click="payVisible = true"
            >
              订单付款</el-button
            >
            <el-button type="success" size="mini" @click="output">
              导出</el-button
            >
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            border
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              type="selection"
              width="55"
              :selectable="checkboxInit"
            >
            </el-table-column>
            <el-table-column prop="id" label="冻结单编号"></el-table-column>
            <el-table-column
              prop="status_text"
              label="冻结单状态"
              align="center"
            >
              <!--<template slot-scope="scope">-->
              <!--{{getFreezeStatus(scope.row.status)}}-->
              <!--</template>-->
            </el-table-column>
            <el-table-column prop="supply_id" label="商家ID" align="center">
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pg_member_name"
              label="代采员"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="bill_amount"
              label="账单金额"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="freeze_amount"
              label="冻结金额（%）"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.freeze_amount }}({{
                  Number(scope.row.freeze_rate) * 100
                }}%)
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="冻结日期"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="unfreeze_time"
              label="解冻日期"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="pay_admin" label="转账人" align="center">
            </el-table-column>
            <el-table-column
              prop="pay_time"
              label="转账日期"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="" label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="redirectDetail(scope.row.id)">
                  详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :page-sizes="[10, 50, 100]"
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.count"
            :page-size="form.page_size"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <div v-if="payVisible">
      <pay-tem
        :ids="ids"
        :url="url2"
        :pay_num="pay_num"
        :pay_money="pay_money"
        @onCloseDialog="onCloseDialog"
      ></pay-tem>
    </div>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

import PayTem from "../wcgorder/components/PayOrderTem";
import { freezeBillStatus } from "../../tool/const";

export default {
  components: {
    PayTem,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getPgOption();
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      curPage: 1,
      filterFold: false,
      form: { page_size: 10, pg_member_id: "0" },
      pgOption: [],
      pgMember: [],
      pay_num: 0,
      pay_money: 0.0,
      ids: [],
      freezenOption: freezeBillStatus,
      payVisible: false,
      url2: "/erp/SupplyFreezeBill/payOrder",
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    onCloseDialog(e) {
      this.payVisible = false;
      this.fetchData();
    },
    checkboxInit(row, index) {
      if (row.status != 3) return 0;
      // 不可勾选
      return 1; // 可勾选
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.pay_num = 0;
      this.pay_money = 0.0;
      const multipleSelection = [];
      for (const key in val) {
        this.pay_num += 1;
        this.pay_money += parseFloat(val[key].freeze_amount);
        multipleSelection[key] = val[key].id;
      }
      this.ids = multipleSelection;
    },
    fetchData() {
      this.$http
        .post("/erp/SupplyFreezeBill/getFreezeBillList", this.filteredForm)
        .then((res) => {
          if (res.data.code != 200) {
            return this.$message.error(res.data.msg);
          }
          this.resData = res.data.data;
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    search() {
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.$http
        .post("/erp/SupplyFreezeBill/getFreezeBillList", this.filteredForm)
        .then((res) => {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
    handleCurrentChange() {},
    getPgOption() {
      this.$http.post("/erp/Common/selectPg").then((res) => {
        this.pgOption = res.data.data;
      });
    },
    getPgMember(e) {
      if (!e) {
        return false;
      }
      this.pgMember = [];
      this.form.pg_member_id = "";
      this.$http.post("/erp/Common/getPurchaseMember").then((res) => {
        this.pgMember = res.data.data;
      });
    },
    redirectDetail(id) {
      this.$router.push(`/home/xhhk/freezen-detail/${id}`);
    },
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    getFreezeStatus(status) {
      let text = "";
      this.freezenOption.forEach((row) => {
        if (row.value == status) {
          text = row.label;
        }
      });
      return text;
    },
  },
};
</script>

<style scoped>
.freezen-item {
  width: 200px;
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/xhhk/FreezenBillList.vue